import { makeObservable, observable, action, computed } from 'mobx'

export const makeAutoObservableSuper = (target: object) => {
  const proto = Object.getPrototypeOf(target)
  const allProperties = new Set<string>()

  let currentProto = proto
  while (currentProto && currentProto !== Object.prototype) {
    Object.getOwnPropertyNames(currentProto).forEach((name) => {
      if (name !== 'constructor') {
        allProperties.add(name)
      }
    })
    currentProto = Object.getPrototypeOf(currentProto)
  }

  Object.getOwnPropertyNames(target).forEach((name) => {
    allProperties.add(name)
  })

  const config: Record<string, unknown> = {}

  allProperties.forEach((propertyName) => {
    if (propertyName.startsWith('_')) return
    if (['constructor', 'prototype'].includes(propertyName)) return

    const descriptor =
      Object.getOwnPropertyDescriptor(Object.getPrototypeOf(target).__proto__, propertyName) ||
      Object.getOwnPropertyDescriptor(Object.getPrototypeOf(target), propertyName) ||
      Object.getOwnPropertyDescriptor(target, propertyName)

    if (!descriptor) return

    if (typeof descriptor.value === 'function') {
      config[propertyName] = action
    } else if (descriptor.get) {
      config[propertyName] = computed
    } else {
      config[propertyName] = observable
    }
  })

  makeObservable(target, config)
}
